import { ReactComponent as ArrowLeft } from "./chevron-left.svg";
import { ReactComponent as ArrowRight } from "./chevron-right.svg";

import { useState, useEffect } from "react";

function Carousel(props) {
  const [index, setIndex] = useState(0);

  const pictures = props.pictures;
  const carouselLength = props.carouselLength;

  useEffect(() => {
    const carouselViewport = document.querySelector(".carousel-viewport");
    const slideWidth = carouselViewport.offsetWidth;

    carouselViewport.scroll({
      left: index * slideWidth,
      behavior: "smooth",
    });
  }, [index]);

  return (
    <div className="carousel">
      <div className="carousel-viewport">
        {pictures.map((pic, number = 0) => {
          number++;
          return (
            <div className="carousel__item" id={number} key={number}>
              <img src={pic} alt=""></img>
              <span className="image-index">
                {number}/{carouselLength}
              </span>
            </div>
          );
        })}
      </div>

      {pictures.length === 1 ? (
        ""
      ) : (
        <ArrowLeft
          className="arrow arrow--left"
          onClick={() =>
            index === 0 ? setIndex(carouselLength - 1) : setIndex(index - 1)
          }
        />
      )}

      {pictures.length === 1 ? (
        ""
      ) : (
        <ArrowRight
          className="arrow arrow--right"
          onClick={() =>
            index === carouselLength - 1 ? setIndex(0) : setIndex(index + 1)
          }
        />
      )}
    </div>
  );
}

export default Carousel;
